import React, { useRef, useEffect } from "react";

import ListLink from "../ListLink";

import "./styles.css";

export default function ListMenu({ title, items }) {
  const titleRef = useRef(null);
  const menuRef = useRef(null);
  const containerRef = useRef(null);

  const toggleMenu = () => {
    if (menuRef.current) {
      titleRef.current.classList.toggle("open");
      menuRef.current.classList.toggle("open");
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        // Remove open classes if menu is open
        if (titleRef.current && menuRef.current) {
          titleRef.current.classList.remove("open");
          menuRef.current.classList.remove("open");
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="list-menu" ref={containerRef}>
      <h3
        className="list-menu__title"
        dangerouslySetInnerHTML={{ __html: title }}
        ref={titleRef}
        onClick={toggleMenu}
      ></h3>

      <div className="list-menu__items" ref={menuRef}>
        {items.map((item, index) => (
          <ListLink key={index} title={item.Titulo} href={item.Link} />
        ))}
      </div>
    </div>
  );
}
